// getGiftData.js
'use strict';
import { Collection, fromJS } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getResourceUrl from '../resource/getResourceUrl.js';
import { PUBLIC } from '../resource/resourceUrlTypeConstants.js';
import { GiftUiType } from '../resource/giftConstants.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { PUBLIC_PRODUCT_URL_PATH } from '../RemoteConfigKeys.js';

/**
 * Select gift data by id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - gift id.
 * @return {any} The selected gift data.
 */
const getGiftData = createCachedSelector(
  (state, id) => id,
  (state, id) => state.getIn(['gift', 'items', id]) || fromJS({}),
  (state, id) => state.getIn(['gift', 'items', id, 'uiType']) || '',
  (state, id, dataKey) => dataKey,
  state => getRemoteConfigData(state, PUBLIC_PRODUCT_URL_PATH),
  (id, item, uiType, dataKey, publicProductUrlPath) => {
    let result = item.get(dataKey);
    const isAnimationGift = uiType === GiftUiType.APNG;
    if (dataKey === 'uiType') {
      result = uiType;
    }
    if (dataKey === 'image') {
      /* note:
         because `/gift/${giftId}` just return gift 'id' 'ui_type' and 'price',
         So will to trying to fetch gifts image.
       */
      result = getResourceUrl({
        path: publicProductUrlPath,
        endpoint: `/${id}.png${isAnimationGift ? '?format=SOURCE' : ''}`,
        resourceType: PUBLIC,
      }).href;
    }
    if (dataKey === 'largeImage') {
      result = getResourceUrl({
        path: publicProductUrlPath,
        endpoint: `/${id}_large.png${isAnimationGift ? '?format=SOURCE' : ''}`,
        resourceType: PUBLIC,
      }).href;
    }
    if (dataKey === 'pagImage') {
      const isPagGift = uiType === GiftUiType.PAG;
      if (isPagGift) {
        result = getResourceUrl({
          path: publicProductUrlPath,
          endpoint: `/${id}.pag`,
          resourceType: PUBLIC,
        }).href;
      } else {
        result = null; // non-PAG gift return null
      }
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, id, dataKey) => `${id}:${dataKey}`);

export default getGiftData;
